import { getValue, STORAGE_KEYS } from '../Storage';
import { api } from '../api/apiHandler';
import { doGET } from '../../utils/HttpUtils';
import {
  UtilisationDashboardQuery,
  UtilisationDashboardSnapshot,
} from '../../types/utilisationReports';

const queryString = (query: UtilisationDashboardQuery) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return params.toString();
};

export async function fetchUtilisationDashboard(
  query: UtilisationDashboardQuery
): Promise<UtilisationDashboardSnapshot> {
  const response = await doGET(`/utilisation-reports/dashboard?${queryString(query)}`);
  if (response.status < 200 || response.status >= 400 || !response.data?.data) {
    throw new Error(response.message || 'Failed to load utilisation dashboard');
  }
  return response.data.data;
}

export async function downloadUtilisationDashboardPdf(
  query: UtilisationDashboardQuery,
  fallbackName: string
) {
  const response = await api({
    method: 'GET',
    url: `utilisation-reports/dashboard.pdf?${queryString(query)}`,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getValue(STORAGE_KEYS.TOKEN)}`,
      'x-api-key': 'web',
    },
  });
  const disposition = String(response.headers['content-disposition'] || '');
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = match?.[1] || `${fallbackName}-utilisation.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
